/*
 * 30 minute free delivery offer: ticks the visitor's own clock, shows the welcome pop-up
 * once, and keeps the free delivery discount code on the cart while the clock runs.
 * Config, the clock's start and the fetch wrapper live in snippets/cedar-flash.liquid.
 */
(function () {
  const F = window.CedarFlash;
  if (!F || !F.endsAt || !F.rawFetch) return;

  const root = (F.root || '/').replace(/\/?$/, '/');
  const sameCode = (code) => String(code).toUpperCase() === F.code.toUpperCase();
  let queue = Promise.resolve();

  function saveState(changes) {
    Object.assign(F.state, changes);
    try {
      localStorage.setItem(F.key, JSON.stringify(F.state));
    } catch (e) {}
  }

  /* ---------- Discount code ---------- */

  // The code goes on the cart while the clock runs, even while the cart is still empty (so
  // every way of adding to it and reaching checkout carries the code), and comes off once
  // the clock stops. Checkout runs no theme code, so a checkout opened in time keeps its
  // free delivery.
  function syncCodeOnce() {
    return F.rawFetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => {
        const codes = (cart.discount_codes || []).map((discount) => discount.code);
        const has = codes.some(sameCode);
        const running = F.left() > 0;
        if (has !== running) {
          const next = running ? codes.concat(F.code) : codes.filter((code) => !sameCode(code));
          return F.rawFetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: next.join(',') }),
          }).then((response) => {
            if (!response.ok) throw new Error(`code sync failed (${response.status})`);
            if (!running) saveState({ cleared: true });
          });
        }
        if (!running) saveState({ cleared: true });
      });
  }

  F.syncCode = function () {
    // Once the code has been taken off after the end there is nothing left to look after
    if (F.state.cleared) return Promise.resolve();
    queue = queue.then(syncCodeOnce).catch((error) => console.warn('[cedar-flash]', error));
    return queue;
  };

  /* ---------- Welcome pop-up ---------- */

  let popup;

  function escapeHtml(text) {
    const node = document.createElement('span');
    node.textContent = text || '';
    return node.innerHTML;
  }

  function showPopup() {
    if (popup || F.left() <= 0 || document.documentElement.classList.contains('cedar-gift-pop-open')) return;
    const text = F.text;
    popup = document.createElement('div');
    popup.className = 'cedar-flash-pop cedar-flash-ar';
    popup.innerHTML = `
      <div class="cedar-flash-pop__overlay" data-close></div>
      <div class="cedar-flash-pop__card" role="dialog" aria-modal="true" aria-labelledby="CedarFlashPopTitle" dir="rtl">
        <button type="button" class="cedar-flash-pop__close" aria-label="Close" data-close>&times;</button>
        <p class="cedar-flash-pop__eyebrow">${escapeHtml(text.eyebrow)}</p>
        <h2 class="cedar-flash-pop__title" id="CedarFlashPopTitle">🚚 ${escapeHtml(text.title)}</h2>
        <div class="cedar-flash-clock" dir="ltr" role="timer">
          <span class="cedar-flash-clock__unit"><b data-cedar-flash-unit="m"></b><i>دقيقة</i></span>
          <span class="cedar-flash-clock__sep" aria-hidden="true">:</span>
          <span class="cedar-flash-clock__unit"><b data-cedar-flash-unit="s"></b><i>ثانية</i></span>
        </div>
        <p class="cedar-flash-pop__text">${escapeHtml(text.popup)}</p>
        ${F.gift && text.giftLine ? `<p class="cedar-flash-pop__gift">🎁 ${escapeHtml(text.giftLine)}</p>` : ''}
        <button type="button" class="cedar-flash-pop__btn" data-close>${escapeHtml(text.button)}</button>
      </div>`;
    popup.addEventListener('click', (event) => {
      if (event.target.closest('[data-close]')) closePopup();
    });
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePopup();
    });
    document.body.appendChild(popup);
    F.paint();
    void popup.offsetWidth; // commit the starting state so the fade-in transition runs
    popup.classList.add('is-open');
    popup.querySelector('.cedar-flash-pop__btn').focus({ preventScroll: true });
    saveState({ popupShown: true });
  }

  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.classList.remove('is-open');
    setTimeout(() => (popup.hidden = true), 200);
  }

  /* ---------- Clock ---------- */

  let ticking = false;

  function tick() {
    F.paint();
    if (F.left() > 0) {
      ticking = true;
      setTimeout(tick, 1000 - (Date.now() % 1000));
      return;
    }
    // The clock just ran out on this page: take the code off the cart
    if (ticking) {
      closePopup();
      F.syncCode();
    }
    ticking = false;
  }

  // The "gift added" pop-up and the cart footer: free delivery line with the time left
  F.deliveryHtml = function () {
    if (F.left() <= 0) return '';
    return `<span class="cedar-flash-line cedar-flash-ar" dir="rtl">🚚 ${escapeHtml(F.text.cart)} <b dir="ltr" data-cedar-flash-clock></b></span>`;
  };

  /* ---------- Start ---------- */

  tick();
  F.syncCode();

  // A page restored from the back button, or a tab the visitor comes back to, shows an old clock
  const refresh = () => {
    if (ticking) F.paint();
    else tick();
  };
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });

  const inEditor = window.Shopify && window.Shopify.designMode;
  if (F.popup && !F.state.popupShown && !inEditor && !/\/cart\/?$/.test(location.pathname)) {
    setTimeout(showPopup, 1200);
  }
})();
